export const GAME_COMPARE_PATHNAME = '/ratings';

export const PAIR_LENGTH = 2;

export const ESC_KEY = 'Escape';

export const GAME_COMPARE_LIMIT = 6;

export const ADS_TO_RELOAD = [
  {
    name: 'Billboard',
  },
  {
    name: '240x400',
  },
  {
    name: 'TopBanner',
  },
];

export const ADS_TO_RELOAD_COUNT = 10;

export const TARGET_TYPE = 'Widgets::GameCompare::GameCompare';

export const GAME_CMPARE = 'gameCompare';

export const PAIR_COMPARE = 'pairCompare';

